import { render } from "./Share.vue?vue&type=template&id=4c5a737c&scoped=true"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"

import "./Share.vue?vue&type=style&index=0&id=4c5a737c&lang=scss&scoped=true"

import exportComponent from "E:\\Projects\\leeno\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5a737c"]])

export default __exports__